<template>
  <div ref="modal" class="modal fade" :class="{ show: active, 'd-block': active }" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Question</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" v-on:click="$emit('closeModal')"
            aria-label="btn-close"></button>
        </div>

        <div class="modal-body">


          <form ref="formElement" class="forms-sample" method="POST" @submit.prevent="submitData">
            <div class="modal-body">

              <!--end::loading-data-->
              <!-- <h5>{{ $t("areYouSure") }}</h5> -->

              <div class="mb-3">
                <label class="form-label">Survey Question</label>
                <textarea class="form-control" v-model="question" height="200px"></textarea>
              </div>


              <div class="mb-3">
                <label class="form-label">Control Type</label>
                <v-select :options="fetchControlType" v-model="control_type" label="name" return-object></v-select>
              </div>


              <div v-if="control_type && control_type.name === 'radio_button'" class="mb-3">
                <label class="form-label" v-if="radioOptions.length > 0">Radio Button Options</label>

                <div v-for="(option, index) in radioOptions" :key="index" class="d-flex mb-2">
                  <input type="text" class="form-control me-2" v-model="radioOptions[index]"
                    placeholder="Enter option value" />
                  <button type="button" class="btn btn-danger" @click="removeOption(index)"
                    v-if="radioOptions.length > 0">
                    &times;
                  </button>
                </div>

                <button type="button" class="btn btn-secondary btn-sm mt-2" @click="addOption">
                  + Add Option
                </button>
              </div>


              <!-- <div class="mb-3">
                <label class="form-label">Tire Category</label>
                <v-select :options="fetchTireCategory" v-model="tire_category" label="name" return-object></v-select>
              </div>

              <div v-if="tireCategoryValues.length" class="mb-3">
                <label class="form-label">Tire Values ({{ tireCategoryValues.length }})</label>

                <div v-for="(val, index) in tireCategoryValues" :key="index" class="mb-2">
                  <input type="text" class="form-control" v-model="tireCategoryValues[index]"
                    :placeholder="`Value ${index + 1}`" />
                </div>
              </div> -->

              <div class="mb-3">
                <label class="form-label">Page</label>
                 <input class="form-control" type="number" v-model="page" />
              
              </div>

              <div class="mb-3">
                <label class="form-label">Order</label>
                <input class="form-control" type="number" v-model="order" />
                <!-- <v-select :options="fetchOrder" v-model="order" label="name" return-object></v-select> -->
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <div>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" id="checkDefault" true-value="ENABLED"
                        false-value="DISABLED" v-model="requiredField" />
                      <label class="form-check-label" for="checkDefault">
                        Required
                      </label>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" v-on:click="$emit('closeModal')">
                No
              </button>

              <div v-if="isLoading" class="d-flex align-items-center">
                <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                <strong>Loading...</strong>
              </div>

              <button v-if="!isLoading" class="btn btn-primary" type="submit">Save & Close </button>

            </div>
          </form>


        </div>


      </div>
    </div>
  </div>
</template>

<script>

//   import multiselect from "vue-multiselect";
export default {
  components: {
    // "multiselect": multiselect
  },
  name: "ModalPriority",
  emits: ["closeModal"],
  props: {
    showModal: Boolean,
    data: null,
    action: null,
  },
  watch: {
    showModal: {
      handler(newVal) {
        this.active = newVal;

        const body = document.querySelector("body");
        newVal
          ? body.classList.add("modal-open")
          : body.classList.remove("modal-open");

        if (!this.data) {
          this.resetFormData();
        } else {
          console.log(this.data.m_p2h_question_detail_id);
          // Isi field dari this.data
          this.question = this.data.question || "";

          this.page = this.data.page;
          this.order = this.data.order;

          this.control_type = this.fetchControlType.find(ct => ct.name === this.data.control_type) || "";

          this.requiredField = this.data.required === 1 ? "ENABLED" : "DISABLED";

          // Handle subdetails untuk radio button
          if (this.data.subdetails && Array.isArray(this.data.subdetails)) {
            this.radioOptions = this.data.subdetails.map(s => s.value);
          } else {
            this.radioOptions = [''];
          }
        }
      },
      immediate: true,
      deep: true,
    },

    tire_category(newVal) {
      if (newVal && newVal.name) {
        this.tireCategoryValues = Array(newVal.name).fill('');
      } else {
        this.tireCategoryValues = [];
      }
    }
  },
  data() {
    return {
      question: "",
      radioOptions: [''],
      requiredField: true,
      tireCategoryValues: [],
      fetchTireCategory: [
        {
          name: 4,
        },
        {
          name: 6,
        },
        {
          name: 10,
        },
        {
          name: 22,
        },
      ],
      fetchOrder: [
        {
          name: 1,
        },
        {
          name: 2,
        },
        {
          name: 3,
        },
        {
          name: 4,
        },
        {
          name: 6,
        },
        {
          name: 7,
        },
        {
          name: 8,
        },
        {
          name: 9,
        },
        {
          name: 10,
        },
      ],

      fetchPage: [
        {
          name: 1,
        },
        {
          name: 2,
        },
        {
          name: 3,
        },
        {
          name: 4,
        },
        {
          name: 6,
        },
        {
          name: 7,
        },
        {
          name: 8,
        },
        {
          name: 9,
        },
        {
          name: 10,
        },
      ],
      page: "",
      order: "",
      tire_category: "",
      fetchControlType: [
        {
          name: 'radio_button',
        },
        {
          name: 'photo',
        },
        {
          name: 'field',
        },
        {
          name: 'tire',
        }
      ],
      control_type: '',
      isLoadingReset: false,
      classColapsed: '',
      isLoading: false,
      active: this.showModal,
      forms: [],
      fetch_auto_load: [],
      auto_load: "",
      errors: [],
      locale: [],
      report_date: [],
      pickup_date: "",
      delivery_date: "",
      groupByCategory: [],
      type_error: [],
      rows: [],
      prioritycek: [],
      activePriority_1: false,
      activePriority_2: false,
      activePriority_3: false,
      activePriority_4: false,
      activePriority_5: false,
      activePriority_6: false,
      activePriority_7: false,
      activePriority_8: false,
      activePriority_9: false,
      activePriority_10: false,
      dataPriority_1: [],
      dataPriority_2: [],
      dataPriority_3: [],
      dataPriority_4: [],
      dataPriority_5: [],
      dataPriority_6: [],
      dataPriority_7: [],
      dataPriority_8: [],
      dataPriority_9: [],
      dataPriority_10: [],
      fetchDriver: [],
      detailShiftWithRef: [],
      planing: [],
    };
  },
  methods: {
    resetFormData() {

      this.question = "";
      this.order = "";
      this.page = "";
      this.tire_category = "";
      this.control_type = "";
      this.fetch_auto_load = [];
      this.tireCategoryValues = [];
      this.radioOptions = [''];
      this.requiredField = true;
      this.isLoading = false;
      this.isLoadingReset = false;
    },

    reset() {
      this.rows = [];
      this.groupByCategory = [];
      this.loadItems(this.data[0].transport_order_header_id);
    },





    setPriority(i, index) {
      this.planing = [];
      console.log(this.groupByCategory[0][i][index]);
      this.planing.push(this.groupByCategory[0][i][index]);


      console.log(this.planing);
      // console.log(ev);
      // var data={
      //   vehicle_no:row2.vehicle_no,
      //   value:'',
      // }
      // console.log(data);
    },

    uniqByKeepLast(a, key) {
      return [
        ...new Map(
          a.map(x => [key(x), x])
        ).values()
      ]
    },

    customLabel2(ev) {
      if (ev.name == 'Yes') {
        return "YES - Shipment - Load Id - Appoint Load";
      } else if (ev.name == 'No') {
        return "NO - Shipment - Load Id";
      } else {
        return "Manual - Shipment Only";
      }
    },

    errorAlert(msg) {
      this.$swal({
        icon: 'danger',
        backdrop: true,
        title: "Information",
        html: "<p>* " + msg + "</p>",
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
    },


    submitData() {

      this.isLoading = true;

      let subdetails = this.radioOptions
        .filter(val => val !== "")
        .map(val => ({ value: val }));

      var m_p2h_question_detail_id = this.data && this.data.m_p2h_question_detail_id != null
        ? this.data.m_p2h_question_detail_id
        : null;
      var detail = {
        "m_p2h_question_detail_id": m_p2h_question_detail_id,
        "page": this.page,
        "order": this.order,
        "question": this.question,
        "required": this.requiredField === "ENABLED" ? 1 : 0,
        "control_type": this.control_type.name,
        "subdetails": subdetails,
      }
      console.log(detail);

      this.isLoading = false;

      this.$emit("closeModal");
      this.$emit("showDataFromModal", detail);



    },


    addOption() {
      this.radioOptions.push('');
    },
    removeOption(index) {
      this.radioOptions.splice(index, 1);
    },


    success2(msg) {

      this.$swal({
        icon: 'info',
        backdrop: true,
        title: "Information",
        html: "<p>* " + msg + "</p>",
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })


    },

    loadItems(transport_order_header_id) {
      this.rows = [];
      const baseURI = this.$settings.endPointCt + "truck-priority/select/" + transport_order_header_id;
      return this.$http
        .get(
          baseURI,
          { timeout: 10000 }
        )
        .then((response) => {

          this.rows = response.data.datas;
          this.groupByCategory = [];
          var groupByCategory = this.rows.reduce((group, row) => {
            const { priority } = row;
            group[priority] = group[priority] ?? [];
            row['checkbox'] = false;
            group[priority].push(row);
            return group;
          }, {});


          this.groupByCategory.push(groupByCategory);




          // this.totalRecords = response.data.datas.total;
          // this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {

            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push('/server-error');
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push('/page-not-found');
              }
            }

          }

        });
    },


    cekDetailShipwithRef(vehicle_no) {
      console.log(this.detailShiftWithRef.length);
      for (let index = 0; index < this.detailShiftWithRef.length; index++) {
        if (this.detailShiftWithRef[index].vehicle_no == vehicle_no) {
          return true;
        }
      }
    },


    resetData() {
      this.isLoadingReset = true;
      for (let index = 0; index < this.detailShiftWithRef.length; index++) {
        this.detailShiftWithRef[index]['checkbox'] == false;
      }
      console.log(this.detailShiftWithRef);
      this.isLoadingReset = false;
    },


    loadShipWithRef(shipwith_ref) {

      const baseURI = this.$settings.endPointCt + "planning?shipwithref=" + shipwith_ref;
      return this.$http
        .get(
          baseURI,
          { timeout: 10000 }
        )
        .then((response) => {
          this.detailShiftWithRef = [];
          this.detailShiftWithRef = response.data.datas;
          console.log(this.detailShiftWithRef);
          // this.totalRecords = response.data.datas.total;
          // this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {

            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push('/server-error');
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push('/page-not-found');
              }
            }

          }

        });
    },



    loadPriority(no) {

      console.log(no);
      if (no == 1) {
        this.activePriority_1 = !this.activePriority_1;

      }

      if (no == 2) {
        this.activePriority_2 = !this.activePriority_2;
      }

      if (no == 3) {
        this.activePriority_3 = !this.activePriority_3;
      }

      if (no == 4) {
        this.activePriority_4 = !this.activePriority_4;
      }

      if (no == 5) {
        this.activePriority_5 = !this.activePriority_5;
      }

      if (no == 6) {
        this.activePriority_6 = !this.activePriority_6;

      }

      if (no == 7) {
        this.activePriority_7 = !this.activePriority_7;
      }

      if (no == 8) {
        this.activePriority_8 = !this.activePriority_8;
      }

      if (no == 9) {
        this.activePriority_9 = !this.activePriority_9;
      }

      if (no == 10) {
        this.activePriority_10 = !this.activePriority_10;
      }


    }
  },
  mounted() {
    //tail(this.data);
  },
};
</script>

<style scoped>
.modal {
  background: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background: #fff;
  border-radius: 0px;
  border: none;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  padding: 0px;
  width: 100%;
  height: 100%;
  margin-left: 0px !important;
}
</style>